export const loanFieldConfiguration = [
  {
    name: "loanFlag",
    label: "Ownership",
    type: "select",
    options: [
      { label: "Loan", value: "LOAN" },
      { label: "Rent", value: "RENT" },
      { label: "Own", value: "OWN" },
    ],
    validation: { required: "Ownership type is required" },
  },
  {
    name: "lenderId",
    label: "Lender",
    type: "combo",
    dataKey: "lenders",
    validation: { required: "Lender is required" },
  },
  {
    name: "loanAmount",
    label: "Loan Amount",
    type: "number",
    validation: { required: "Loan amount is required" },
  },
  {
    name: "loanNumber",
    label: "Loan Number",
    type: "text",
    validation: { required: "Loan number is required" },
  },
  {
    name: "loanStartDate",
    label: "Loan Start Date",
    type: "date",
    validation: { required: "Start date is required" },
  },
  {
    name: "loanEndDate",
    label: "Loan End Date",
    type: "date",
    validation: { required: "End date is required" },
  },
  {
    name: "loanTermMonths",
    label: "Loan Term (Months)",
    type: "number",
    validation: { required: "Loan term is required" },
  },
  {
    name: "interestRate",
    label: "Interest Rate",
    type: "number",
    validation: { required: "Interest rate is required" },
  },
  {
    name: "monthlyPayment",
    label: "Monthly Payment",
    type: "number",
    validation: { required: "Monthly payment is required" },
  },
];

export const loanInitialValues = {
  loanFlag: "",
  lenderId: "",
  loanAmount: 0,
  loanNumber: "",
  loanStartDate: "",
  loanEndDate: "",
  loanTermMonths: 0,
  interestRate: 0,
  monthlyPayment: 0,
};
